
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/article/teamsreminder-mobile-management-guide",
      function () {
        return require("private-next-pages/article/teamsreminder-mobile-management-guide.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/article/teamsreminder-mobile-management-guide"])
      });
    }
  